import axios from "axios";

const opendota = axios.create({
  baseURL: "https://api.opendota.com/api/",
});

export default opendota;
